<template>
  <v-container
    id="account"
    tag="section"
  >
    <base-v-component
      :heading="$t('account')"
      :subtitle="$t('account-subtitle')"
    />

    <v-tabs
      v-model="tab"
      background-color="transparent"
      grow
    >
      <v-tab>
        {{ $t('company') + ' & ' + $t('workspaces')}}
      </v-tab>
      <v-tab>
        {{ $t('profile') }}
      </v-tab>
    </v-tabs>

    <v-tabs-items v-model="tab">
  
      <!-- COMPANY & WORKSPACES -->
      <v-tab-item>

        <!-- ACCOUNT TYPE -->
        <!--
        <v-card class="mx-auto" v-if="pricing">
          <v-toolbar dark>
            <v-toolbar-title>{{ $t('account-type') }}</v-toolbar-title>
          </v-toolbar>
          <v-card-text>
            <v-container>
              <v-row v-if="paymentLoading">
                <v-text-field color="primary" loading disabled class="px-10" />
              </v-row>
              <v-row v-if="!paymentLoading && company">
                <p class="h6">{{ company.companyName }} is currently on the <strong>{{ companySubscription && companySubscription.type ? companySubscription.type : 'free'}} plan</strong></p>
              </v-row>

              <template v-if="isAdmin">
              <v-row v-if="!paymentLoading && companySubscription">
                <v-btn
                  color="primary"
                  @click="toCustomerPortal()"
                >
                  To Customer Portal
                </v-btn>
              </v-row>
              <v-row v-if="!paymentLoading && !companySubscription && pricing">
                <v-col 
                v-for="item in pricing"
                :key="item.id"
                >
                  <v-card
                    class="mx-auto py-4 px-4"
                    max-width="344"
                  >
                    <v-card-title>
                      {{ item.name }}
                    </v-card-title>
                    <v-spacer/>
                    <v-card-subtitle>
                      <p class="h3">{{ getPrice(item).amount }} {{ getPrice(item).currency }}</p>
                      <v-spacer />
                      <ul>
                        <li
                        v-for="(content, index) in item.content"
                        :key="'content-'+index"
                        >
                          {{ content }}
                        </li>
                      </ul>
                    </v-card-subtitle>

                    <v-card-actions>
                      <v-btn
                        color="primary"
                        @click="initCheckout(item)"
                      >
                        Subscribe
                      </v-btn>

                      <v-spacer></v-spacer>
                    </v-card-actions>
                  </v-card>
                </v-col>
              </v-row>
              </template>
            </v-container>
          </v-card-text>
        </v-card>
        -->

        <v-card class="mx-auto">
          <v-toolbar dark>
            <v-toolbar-title>{{ $t('account-type') }}</v-toolbar-title>
          </v-toolbar>
          <v-card-text>
            <v-container>
            <UpgradeAccount />
            </v-container>
          </v-card-text>
        </v-card>

        <!-- COMPANY INFORMATION -->
        <v-card class="mx-auto">
          <v-toolbar
            dark
          >
          <v-toolbar-title>{{ $t('company-information') }}</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-btn
              v-if="isAdmin"
              color="primary"
              class="mr-0"
              small
              rounded
              @click="onUpdateCompany"
            >
              {{ $t('update') }}
            </v-btn>
          </v-toolbar>
          <v-card-text v-if="company">
            <v-text-field
              v-model="company.companyName"
              :label="$t('company-name')"
              :disabled="!isAdmin"
            />
            <v-text-field
              v-model="company.companyNumber"
              :label="$t('company-number')"
              :disabled="!isAdmin"
            />
            <v-row>
              <v-col cols="6">
                <v-autocomplete
                  v-model="selectedCountry"
                  :items="countryRegionData"
                  return-object
                  item-text="countryName"
                  item-value="countryName"
                  hide-no-data
                  hide-details
                  :label="$t('company-country')"
                />
              </v-col>
              <v-col cols="6">
                <v-autocomplete
                  v-model="company.city"
                  :items="regionsData"
                  item-text="name"
                  item-value="name"
                  hide-no-data
                  hide-details
                  :label="$t('company-city')"
                />
              </v-col>
              <v-col cols="12">
                <v-text-field
                  v-model="company.address"
                  :label="$t('company-address')"
                  :disabled="!isAdmin"
                  :hint="$t('optional-use-in-template')"
                />
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>

        <v-card class="mx-auto">
          <v-toolbar dark>
            <v-toolbar-title>{{ $t('workspaces') }}</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-btn
              v-if="isAdmin"
              color="primary"
              class="mr-0"
              small
              rounded
              @click="onCreateProject"
            >
              {{ $t('new') }}
            </v-btn>
          </v-toolbar>
          <v-list two-line subheader>
            <div
              v-if="!projects.length"
              class="text-center pa-6">
              {{ $t('workspace-missing-long')}}
            </div>
            <v-list-item
              v-for="item in projects"
              :key="item.name"
              @click="onEditProject(item)"
            >
              <v-list-item-content>
                <v-list-item-title style="font-size:20px;" v-text="item.name"></v-list-item-title>
                <v-list-item-subtitle v-text="item.default ? '(default)' : ''"></v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>
          </v-list>
        </v-card>

        <!-- COMPANY USERS -->
        <v-row v-if="isAdmin">
          <v-col>
          <v-toolbar
              dark
            >
              <v-toolbar-title>{{ $t('company-users') }}</v-toolbar-title>
              <v-spacer></v-spacer>
              <v-btn
                color="primary"
                class="mr-0"
                small
                rounded
                @click="dialogInvites = true"
              >
                {{ $t('new-invite') }}
              </v-btn>
            </v-toolbar>
          <v-data-table
            :headers="companyUsersHeaders"
            :items="companyUsers"
          >
             <template v-slot:item.name="{item}">
              {{ item.firstName + ' ' + item.lastName }}
            </template>
            <template v-slot:item.status="{item}">
              {{ $t(item.status) }}
            </template>
             <template v-slot:item.added="{item}">
              {{ $moment(new Date(item.added)).format('YYYY-MM-DD') }}
            </template>
          </v-data-table>
          </v-col>
        </v-row>
      </v-tab-item>

       <!-- PROFILE -->
      <v-tab-item>
        <v-row>
          <v-col
            cols="12"
            md="7"
          >
          <v-card class="mx-auto">
            <v-toolbar dark>
              <v-toolbar-title>{{ $t('user') }}</v-toolbar-title>
              <v-spacer></v-spacer>
              <v-btn
                color="primary"
                class="mr-0"
                small
                rounded
                @click="onUpdateUser"
              >
              {{ $t('update') }}
              </v-btn>
            </v-toolbar>

            <v-container class="py-0">
              <v-row>
                <v-col
                  cols="12"
                  md="6"
                >
                  <v-text-field
                    v-model="userObject.firstName"
                    :label="$t('first-name')"
                  />
                </v-col>
                <v-col
                  cols="12"
                  md="6"
                >
                  <v-text-field
                    v-model="userObject.lastName"
                    :label="$t('last-name')"
                  />
                </v-col>
                <v-col cols="12">
                  <v-text-field
                    v-model="user.email"
                    :label="$t('email')"
                    readonly
                    disabled
                  />
                </v-col>
                <v-col
                  cols="12"
                  class="text-right"
                >
                </v-col>
              </v-row>
            </v-container>
          </v-card>
          </v-col>
          <v-col
            cols="12"
            md="5"
          >
          <v-card class="mx-auto">
            <v-toolbar dark>
              <v-toolbar-title>{{ $t('preferences') }}</v-toolbar-title>
            </v-toolbar>

            <v-container class="py-0">
              <v-row>
                <v-col>
                  <v-select
                    :value="$root.$i18n.locale"
                    :items="languages"
                    :label="$t('language')"
                    @change="setLanguage"
                  />
                  <v-select
                    :value="$vuetify.theme.dark"
                    :items="theme"
                    :label="$t('theme')"
                    @change="setDarkMode"
                  />
                </v-col>
              </v-row>
            </v-container>
          </v-card>
          </v-col>
        </v-row>
        <!--
        <v-row 
          align="center"
          justify="center"
          class="my-8"
        >
          <v-btn
            color="warning"
            class="mr-0"
            rounded
            outlined
            @click="signOut"
          >
            {{ $t('signOut') }}
          </v-btn>
        </v-row>
        -->

      </v-tab-item>
    </v-tabs-items>

    <!-- DIALOG WORKSPACE -->
    <template>
      <v-row justify="center">
        <v-dialog
          v-model="dialogProject"
          max-width="700px"
        >
          <v-card>
            <v-card-title>
              <span class="headline">{{ isDialogCreateProduct ? $t('project-new') : $t('project-edit') }}</span>
            </v-card-title>
            <v-card-text>
              <v-text-field
                v-model="editingObject.name"
                :label="$t('project-name')"
                :disabled="!isAdmin"
              />
            </v-card-text>
            <v-card-actions>
              <v-spacer />
              <v-btn
                color="warning"
                text
                @click="dialogProject = false"
              >
                {{ $t('cancel') }}
              </v-btn>
              <v-btn
                color="primary"
                text
                @click="saveItem"
              >
                {{ $t('save') }}
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-row>
    </template>

    <!-- DIALOG INVITES -->
    <template>
      <v-row justify="center">
        <v-dialog
          v-model="dialogInvites"
          max-width="700px"
        >
          <v-card>
            <v-card-title>
              <span class="headline">{{ $t('invite-users') }}</span>
            </v-card-title>
            <v-card-text>
              <v-container fluid>
                <v-layout wrap>
                  <v-flex xs12>
                    <h3>{{ $t('workspace') }}</h3>
                    <span class="caption">{{ $t('select-one') }}</span>
                    <v-checkbox 
                      v-for="item in projects"
                      :key="item.id"
                      v-model="inviteProjectList"
                      :label="item.name"
                      :value="item.id"
                    />
                    <h3>{{ $t('users') }}</h3>
                    <v-combobox
                      multiple
                      v-model="select" 
                      :label="$t('add-emails')" 
                      append-icon
                      chips
                      deletable-chips
                      class="tag-input"
                      :search-input.sync="search" 
                      @keyup.tab="updateTags"
                      @paste="updateTags"
                    >
                    </v-combobox>
                  </v-flex>
                </v-layout>
              </v-container>
            </v-card-text>
            <v-card-actions>
              <v-spacer />
              <v-btn
                color="warning"
                text
                @click="dialogInvites = false"
              >
                {{ $t('cancel') }}
              </v-btn>
              <v-btn
                color="primary"
                text
                :disabled="!inviteProjectList.length || !select.length"
                @click="addInvites"
              >
                {{ $t('send-invite') }}
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-row>
    </template>

  </v-container>
</template>

<script>

  import * as countryData from 'country-region-data';

  import { inviteService } from '@/services/InviteService'
  //import { paymentService } from '@/services/PaymentService'

  import UpgradeAccount from '@/components/UpgradeAccount'

  export default {
    name: 'Account',
    components: {
      UpgradeAccount
    },
    data: function () {
      return {
        inviteService: null,
        //paymentService: null,
        dialogProject: false,
        isDialogCreateProduct: true,
        tab: null,
        tabs: [
          'Company',
          'Workspaces',
          'Profile'
        ],
        editingObject: {
          name: ''
        },
        userObject: {
          firstName: '',
          lastName: '',
          email: ''
        },
        languages: [
          { text: 'English', value: 'en' },
          { text: 'Svenska', value: 'sv' },
        ],
        theme: [
          { text: this.$i18n.t('themeDark'), value: true },
          { text: this.$i18n.t('themeLight'), value: false },
        ],
        companyObject: {
          companyName: '',
          companyNumber: ''
        },
        companyUsersHeaders: [
          { text: 'Name', value: 'name' },
          { text: 'Email', value: 'email' },
          { text: 'Status', value: 'status' },
          { text: 'Added', value: 'added' },
        ],
        select: [],
        search: '',
        error: '',
        dialogCompanyUsers: false,
        dialogInvites: false,
        inviteProjectList: [],

        /*
        pricing: [],
        paymentLoading: false,
        pricingTable: [
          {
            stripeId: "prod_Hw44AdUFRe1t9Q",
            title: "Free",
            value: "0",
            active: false,
            perMonth: false,
            content: [
              "3 products",
              "1 document template",
              "1 workspace",
              "1 user",
            ],
          },
          {
            stripeId: "prod_HuaQz1wZkJtXHK",
            title: "Enhanced",
            value: "290",
            perMonth: true,
            content: [
              "30 products",
              "3 document templates",
              "2 workspaces",
              "3 users",
            ],
          },
          {
            stripeId: "prod_HuaTGA5Qni6i5P",
            title: "Ultimate",
            value: "490",
            perMonth: true,
            content: [
              "Unlimited products",
              "Unlimited document templates",
              "Unlimited workspaces",
              "Unlimited users",
            ],
          },
        ],
        */
        countryRegionData: [],
        regionsData: [],
        selectedCountry: null,
      }
    },

    created() {
      this.resetEditingObject()
      //this.getPricing()
      this.countryRegionData = countryData.default;

      if (this.company && this.company.country) {
        this.selectedCountry = {
          'countryName': this.company.country,
        }
      }
    },

    watch: {
      select: function(newArr) {
        const val = newArr[newArr.length-1]
        if(val) {
          if(!this.isValidEmail(val)) {
            this.select.splice(newArr.length-1)
          }
        }
      },
      company: function(newVal) {
        if(!newVal) return;
        if(newVal.id && this.isAdmin) {
          this.$store.dispatch('company/fetchCompanyUsers', newVal.id)
        }
        if(newVal.country) {
          this.selectedCountry = {
            'countryName': newVal.country,
          }
        }
      },
      selectedCountry: function(val) {
        if (val && val.countryName) {
          this.company.country = val.countryName;
          const country = this.countryRegionData.find((item) => item.countryName === val.countryName)
          this.regionsData = country ? country.regions : []
        }
      }
    },

    computed: {
      access() {
        return this.$store.getters["company/getAccess"];
      },
      user() {
        const res = this.$store.getters['user/getUser']
        this.setUserObject(res)
        return res
      },
      projects() {
        const res = this.$store.getters['projects/getProjects']
        return JSON.parse(JSON.stringify(res));
      },
      company() {
        const res = this.$store.getters['company/getCompany']
        return JSON.parse(JSON.stringify(res))
      },
      companyUsers() {
        return this.$store.getters['company/getUsers']
      },
      isAdmin () {
        return this.company && this.company.ownerId === this.user.id
      },
      companySubscription() {
        return this.$store.getters['company/getSubscription']
      },
    },

    methods: {
      resetEditingObject () {
        this.editingObject = {
          name: '',
          companyId: this.company.id,
          ownerId: this.user.id,
        }
      },
      setUserObject (res) {
        this.userObject = JSON.parse(JSON.stringify(res));
      },
      setLanguage (lang) {
        this.$root.$i18n.locale = lang
        localStorage.setItem('language', lang)
      },
      setDarkMode (isDarkMode) {
        this.$vuetify.theme.dark = isDarkMode
        localStorage.setItem('darkMode', isDarkMode)
      },
      /*
      async getPricing () {
        this.pricing = await paymentService.getPricing();
        this.pricing.forEach((item) => {
          item.content = this.getPricingContent(item)
        })
      },
      getPrice (item) {
        if (!item.prices) return;
        const a = item.prices[0].unit_amount;
        return {
          'amount': (a-(a%100))/100,
          'currency': item.prices[0].currency
        }
      },
      getPricingContent (item) {
        return this.pricingTable.find((price) => price.stripeId === item.id).content;
      },
      initCheckout (item) {
        this.paymentLoading = true;
        const priceId = item.prices[0].id
        paymentService.initCheckout(this.user.id, this.company.id, priceId, this.$route.fullPath)
      },
      toCustomerPortal () {
        this.paymentLoading = true;
        paymentService.toCustomerPortal();
      },
      */
      onUpdateUser () {
        this.$store.dispatch('user/updateUser', this.userObject)
      },
      onUpdateCompany () {
        this.$store.dispatch('company/updateCompany', this.company)
          .then(() => {
            this.$notify({
              group: 'base',
              type: 'success',
              title: 'Company updated',
              text: 'Company has been successfully updated'
            })
          })
          .catch(() => {
            this.$notify({
              group: 'base',
              type: 'error',
              title: 'Oops, something went wrong',
              text: 'The company has not been updated. Please try again.'
            })
          })
      },
      onInviteCompanyUser () {
        console.log('invite company user')
      },
      onEditProject (item) {
        this.resetEditingObject()
        this.editingObject = item
        this.isDialogCreateProduct = false
        this.dialogProject = true
      },
      onCreateProject () {
        this.resetEditingObject()

        if (!this.access.projects) {
          this.$emit('showSnackbar', {
            text: "You've reached the limit for your subscription plan.",
            button: "Upgrade",
            routeTo: "account",
          });
          return null;
        }

        this.isDialogCreateProduct = true
        this.dialogProject = true
      },
      saveItem () {
        if(this.isDialogCreateProduct) {
          const payload = {
            project: this.editingObject,
            user: this.user,
          }
          this.$store.dispatch('projects/createProject', payload)
        } else {
          this.$store.dispatch('projects/updateProject', this.editingObject)
        }
        this.dialogProject = false
        this.resetEditingObject()
      },
      isValidEmail (value) {
        const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
        return pattern.test(value)
      },
      updateTags () {
        this.$nextTick(() => {
          if(this.search){
            this.select.push(...this.search.split(','))
            this.$nextTick(() => {
              this.search = ''
            });
          }
        });
      },
      async addInvites () {
        try {
          if (!this.company && !this.user) {
            throw Error;
          }

          const arr = []
          this.select.forEach((email) => {
            arr.push({
              ownerId: this.user.id,
              companyId: this.company.id,
              companyName: this.company.companyName,
              email,
              valid: true,
            })
          })

          await this.createInvites(arr)         
            .then(() => {
              this.$notify({
                group: 'base',
                type: 'success',
                title: 'Invites sent',
                text: 'Invites has been successfully sent'
              })
              this.dialogInvites = false
              return true
            })
            .catch((error) => {
              console.log('Error calling InviteService/addInvites', error);
              this.$notify({
                group: 'base',
                type: 'error',
                title: 'Oops, something went wrong',
                text: 'The invites has not been succesfully sent. Please try again.'
              })
              return false
            })
        }
        catch (error) {
          console.error('account/addInvites error', error)
        }
      },
      async createInvites (arr) {
        const promises = [];
        arr.forEach((item) => {
          promises.push(inviteService.addInvite(item, this.inviteProjectList))
        });
        return await Promise.all(promises)
      },
      signOut () {
        this.$authService.authSignOut()
      }
    },
  }
</script>

<style scoped>
.tag-input span.chip {
  background-color: #1976d2;
  color: #fff;
  font-size: 1em;
}

.tag-input span.v-chip {
  background-color: #1976d2;
  color: #fff;
  font-size:1em;
  padding-left:7px;
}

.tag-input span.v-chip::before {
    content: "label";
    font-family: 'Material Icons';
    font-weight: normal;
    font-style: normal;
    font-size: 20px;
    line-height: 1;
    letter-spacing: normal;
    text-transform: none;
    display: inline-block;
    white-space: nowrap;
    word-wrap: normal;
    direction: ltr;
    font-feature-settings: 'liga';
    -webkit-font-feature-settings: 'liga';
    -webkit-font-smoothing: antialiased;
}
</style>